<template>
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <b-tabs v-model="addTab">
            <b-tab title="الموافقة علي المقترح ">
              <app-timeline>
                <app-timeline-item
                  v-for="item in items"
                  :key="item.id"
                  :title="$t(`master.` + item.key)"
                  :subtitle="variant(item) ? 'في انتظار الموافقة ' : 'موافقة '"
                  :time="moment(item.updated_at).fromNow()"
                  :variant="variant(item) ? 'danger' : 'success'"
                />
              </app-timeline>
              <b-spinner
                v-if="load"
                type="grow"
                label="Loading..."
                class="loading"
              />
            </b-tab>
            <b-tab @click="newItem = {}" :title="$t('site.add')">
              <form-wizard
                color="#d02578"
                :subtitle="null"
                :title="null"
                :finish-button-text="$t('site.finish')"
                :back-button-text="$t('site.back')"
                :next-button-text="$t('site.next')"
                @on-complete="formSubmitted"
                :start-index="tab"
                step-size="sm"
                ref="wizard"
              >
                <b-card>
                  <tab-content
                    :title="$t('master.general_idea_of_the_topic')"
                    :before-change="
                      () => validateStep('general_idea_of_the_topic')
                    "
                  >
                    <upload-vue
                      ref="general_idea_of_the_topic"
                      datakey="general_idea_of_the_topic"
                      :master="masterId"
                      :files="general_idea_of_the_topic"
                    />
                  </tab-content>
                  <tab-content
                    :title="$t('master.suggested_title')"
                    :before-change="() => validateStep('suggested_title')"
                  >
                    <upload-vue
                      ref="suggested_title"
                      datakey="suggested_title"
                      :master="masterId"
                      :files="suggested_title"
                    />
                  </tab-content>
                  <tab-content
                    :title="$t('master.research_field')"
                    :before-change="() => validateStep('research_field')"
                  >
                    <upload-vue
                      ref="research_field"
                      datakey="research_field"
                      :master="masterId"
                      :files="research_field"
                    />
                  </tab-content>
                </b-card>
              </form-wizard>
            </b-tab>
          </b-tabs>
        </div>
        <br />
        <div class="card-footer text-muted">
          <div class="row">
            <div class="col-sm-2">موافقة القسم</div>
            <div class="col-sm-4">
              <b-badge v-if="department_approval === null">
                في انتظار الموافقة
              </b-badge>
              <b-badge
                variant="light-danger"
                v-else-if="department_approval.value === 0"
              >
                تم الرفض
              </b-badge>
              <b-badge
                variant="light-success"
                v-else-if="department_approval.value === 1"
              >
                تم الموافقة
              </b-badge>
            </div>
            <div class="col-sm-2">موافقة الكلية</div>
            <div class="col-sm-4">
              <b-badge v-if="college_approval === null">
                في انتظار الموافقة
              </b-badge>
              <b-badge
                variant="light-danger"
                v-else-if="college_approval.value === 0"
              >
                تم الرفض
              </b-badge>
              <b-badge
                variant="light-success"
                v-else-if="college_approval.value === 1"
              >
                تم الموافقة
              </b-badge>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-2">تاريخ الموافقة</div>
            <div class="col-sm-4">
              <b-badge variant="light-info" v-if="college_approval != null">
                {{ moment(college_approval.updated_at).fromNow() }}</b-badge
              >
            </div>
            <div class="col-sm-2">تاريخ الموافقة</div>
            <div class="col-sm-4">
              <b-badge variant="light-info" v-if="department_approval != null">
                {{ moment(department_approval.updated_at).fromNow() }}</b-badge
              >
            </div>
          </div>
        </div>
        <!-- end of card body -->
      </div>
      <!-- end of card -->
    </div>
    <!-- end of col -->
  </div>
</template>

<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import uploadVue from "./wizard/upload.vue";
import Auth from "@/Apis/Auth";
import AppTimeline from "@core/components/app-timeline/AppTimeline.vue";
import AppTimelineItem from "@core/components/app-timeline/AppTimelineItem.vue";
import MastersDataController from "@/Controllers/MastersDataController";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required, min_value, max_value } from "@validations";
import MasterKeyStatusController from "@/Controllers/MasterKeyStatusController";
import Swal from 'sweetalert2'

// Department
export default {
  components: {
    FormWizard,
    TabContent,
    uploadVue,
    AppTimeline,
    AppTimelineItem,
    ValidationProvider,
    ValidationObserver,
    required,
    min_value,
    max_value,
  },
  data() {
    return {
      tab: 0,
      items: [],
      load: true,
      addTab: 1,
      steps : {
        step1 : 0,
        step2 : 0
      },
      research_field: [],
      suggested_title: [],
      general_idea_of_the_topic: [],
      masterId: Auth.MASTER.id,
      proposalApproval: [],
      department_approval: null,
      college_approval: null,
    };
  },
  async created() {
    let userId = Auth.USER.id;
    if (this.$route.params.masterId) {
      this.masterId = this.$route.params.masterId;
      userId = this.$route.params.userId;
    }

    const res = await new MastersDataController().GetAll({
      filter: "user_id|" + userId + "&&master_id|" + this.masterId,
      filterIn: "key|research_field,suggested_title,general_idea_of_the_topic",
      with: ["masterKeyStatus"],
    });
    this.items = res;
    //Steps Validation
    const master_key_inst = new MasterKeyStatusController();
    const verfy_step_1 = await master_key_inst.verifyStep(
      "suggested_title",
      this.masterId
    )
    this.steps.step1 = verfy_step_1;
    const verfy_step_2 = await master_key_inst.verifyStep(
      "research_field",
      this.masterId
    )
    this.steps.step2 = verfy_step_2;
    this.proposalApproval = await new MasterKeyStatusController().GetAll({
      filter: "master_id|" + this.masterId,
      filterIn: "key|department_approval,college_approval",
      with: ["user"],
    });
    this.research_field = this.getData("research_field");
    this.suggested_title = this.getData("suggested_title");
    this.general_idea_of_the_topic = this.getData("general_idea_of_the_topic");
    this.load = false;
    if (res.length == 3) this.addTab = 0;
    const department_approval = this.proposalApproval.find(
      (a) => a.key == "department_approval"
    );

    if (department_approval) this.department_approval = department_approval;
    const college_approval = this.proposalApproval.find(
      (a) => a.key == "college_approval"
    );

    if (college_approval) this.college_approval = college_approval;
  },
  methods: {
    getData(key) {
      const find = this.items.filter((a) => a.key == key);
      if (!find) return [];
      if (find.findIndex((a) => a.key == "research_field") != -1) this.tab = 1;
      if (find.findIndex((a) => a.key == "general_idea_of_the_topic") != -1)
        this.tab = 2;
      this.$refs["wizard"].changeTab(0, this.tab);

      return find;
    },
    variant(item) {
      return (
        item.master_key_status == null ||
        item.master_key_status.value == null ||
        item.master_key_status.value == "" ||
        item.master_key_status.value == "-1"
      );
    },
    async validateStep(name) {
      const refToValidate = this.$refs[name];
      const returnData = await refToValidate.returnData();
      if (!returnData.valid) return false;

      return true;
    },
    checkStatus(key) {
      if (this.proposalApproval.length == 0) return true;
      const find = this.proposalApproval.find((a) => a.key == key);
      if (find) return false;

      return true;
    },
    getUser(key) {
      if (this.proposalApproval.length == 0) return true;
      const find = this.proposalApproval.find((a) => a.key == key);
      if (find) return find.user.full_name;
    },
    async save() {
      const isValid = await this.$refs.dataForm.validate();
      if (!isValid) {
        return { valid: false };
      }
      this.newItem.key = this.datakey;
      this.newItem.master_id = this.master;

      this.ret = await new MastersDataController().From(this.newItem, true);
    },
    async formSubmitted() {
      this.$router.push({ name: "Thesis" });
    },
    async validateStep(name) {
      const refToValidate = this.$refs[name];
      if (name == "suggested_title") {

        if (this.steps.step1 == 1) return true;
          return this.swalAlert(name);
      }else if(name == "research_field"){
        if (this.steps.step2 == 1) return true;
          return this.swalAlert(name);
      }
      const returnData = await refToValidate.returnData();
      if (!returnData.valid) return this.swalAlert(name);

      return true;
    },
    swalAlert(name) {
      
      Swal.fire({
      // position: 'top-start',
      icon: 'error',
      title: 'في انتظار الموافقة علي  ',
     text:  this.$t('master.'+name),
      // text:   'master: ' + name,
     

      showConfirmButton: false,
      timer: 3000,
    })
     
  },
  },
};
</script>

<style>
</style>